// store/faturas.ts
import { create } from "zustand"
import { FornecedorRaw } from "@/app/api/prenotas/(inclusao)/fornecedor"
import { DateRange } from "react-day-picker"
import { useReactTable } from "@tanstack/react-table"

interface FaturasState {
  fornecedores: FornecedorRaw[]
  setFornecedores: (updater: ((prev: FornecedorRaw[]) => FornecedorRaw[]) | FornecedorRaw[]) => void
  filial: string
  setFilial: (f: string) => void
  date?: DateRange
  setDate: (d: DateRange | undefined) => void
  dataInicial: string
  setDataInicial: (s: string) => void
  dataFinal: string
  setDataFinal: (s: string) => void
  fornecedorFatura: FornecedorRaw | null
  setFornecedorFatura: (f: FornecedorRaw | null) => void
  faturas: any[]
  setFaturas: (f: any[]) => void
  table?: ReturnType<typeof useReactTable<any>>
  setTable: (t: ReturnType<typeof useReactTable<any>>) => void
  isLoading: boolean
  setIsLoading: (l: boolean) => void
  error: Error | null
  setError: (err: Error | null) => void
  observacao: string
  setObservacao: (o: string) => void
  rec: number
  setRec: (rec: number) => void
  // Dados Z15 da fatura principal (para modo edição)
  faturaZ15: {
    Z15_FILIAL: string
    Z15_FORNEC: string
    Z15_LOJA: string
    Z15_COD: string
  }
  setFaturaZ15: (z15: { Z15_FILIAL: string, Z15_FORNEC: string, Z15_LOJA: string, Z15_COD: string }) => void
  resetFaturaStore: () => void
}

export const useFaturasStore = create<FaturasState>((set) => ({
  fornecedores: [],
  setFornecedores: (updater) =>
    set((state) => {
      const next = typeof updater === "function" ? updater(state.fornecedores) : updater
      // 🔒 garante que só entra fornecedor válido
      const filtered = next.filter(
        (f) => f.A2_COD?.trim() && f.A2_LOJA?.trim()
      )

    return { fornecedores: filtered }
  }),
  filial: "",
  setFilial: (filial) => set({ filial }),
  date: undefined,
  setDate: (date) => set({ date }),
  dataInicial: "",
  setDataInicial: (dataInicial) => set({ dataInicial }),
  dataFinal: "",
  setDataFinal: (dataFinal) => set({ dataFinal }),
  fornecedorFatura: null,
  setFornecedorFatura: (f) => set({ fornecedorFatura: f }),
  faturas: [],
  setFaturas: (faturas) => set({ faturas }),
  table: undefined,
  setTable: (table) => set({ table }),
  isLoading: false,
  setIsLoading: (isLoading) => set({ isLoading }),
  error: null,
  setError: (error) => set({ error }),
  observacao: "",
  setObservacao: (observacao) => set({ observacao }),
  rec: 0,
  setRec: (valor: number) => set({ rec: valor }),
  faturaZ15: {
    Z15_FILIAL: "",
    Z15_FORNEC: "",
    Z15_LOJA: "",
    Z15_COD: "",
  },
  setFaturaZ15: (z15) => set({ faturaZ15: z15 }),
  resetFaturaStore: () =>
  set({
    fornecedores: [],
    filial: "",
    date: undefined,
    dataInicial: "",
    dataFinal: "",
    fornecedorFatura: null,
    faturas: [],
    table: undefined,
    isLoading: false,
    error: null,
    observacao: "",
    rec: 0,
    faturaZ15: {
      Z15_FILIAL: "",
      Z15_FORNEC: "",
      Z15_LOJA: "",
      Z15_COD: ""
    }
  }),
}))
